import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonPage,
  IonContent,
  IonItemOption,
} from '@ionic/vue';
import { BasicSearchByCodeBlock } from '@components/basic';
import SelectStocktakingEntryHeader from '@/components/stocktaking/headers/select-stocktaking-entry/SelectStocktakingEntryHeader.vue'
import BasicDocumentListWithInfiniteScroll from '@/components/basic/list/BasicDocumentListWithInfiniteScroll.vue';
import useScanner from '@/composable/useScanner';
import useGetEntryStockTakingDocuments from './_inner/useGetEntryStockTakingDocuments';
import useAggregationPlacementModal from '@/composable/useAggregationPlacementModal';
import FIDocumentPlacesModal from '@/components/stocktaking/modals/FIDocumentPlacesModal.vue'
import { TAttribute } from '@/const/types/attributes';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStocktakingDocumentsEntiresView',
  setup(__props) {

const {
  loadMore,
  handleShowPlaces,
  foundType,
  searchCode,
  documents,
  places,
  isAllWarehouse,
  maxDocuments,
} = useGetEntryStockTakingDocuments();

const { articlesModal: aggregationPlacementModal, canLoadMoreItems } = useAggregationPlacementModal(
  [
    'attributes',
    'aggregatedPlacements.product',
    'aggregatedPlacements.combination',
    'aggregatedPlacements.combination.product',
    'aggregatedPlacements',
  ],
  8
);

const showPlacesForStocktaingDocument = (documentAttributes: TAttribute[]) => {
  handleShowPlaces(documentAttributes);
  aggregationPlacementModal.isOpen = true;
};
useScanner({
  onScan(code) {
    searchCode.value = code;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(SelectStocktakingEntryHeader),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(BasicSearchByCodeBlock), {
            "found-type": _unref(foundType),
            modelValue: _unref(searchCode),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchCode) ? (searchCode).value = $event : null))
          }, null, 8, ["found-type", "modelValue"]),
          _createVNode(BasicDocumentListWithInfiniteScroll, {
            route: "stocktaking/show-document",
            documents: _unref(documents),
            "max-documents": _unref(maxDocuments),
            onLoadMore: _unref(loadMore)
          }, {
            default: _withCtx(({ document }) => [
              _createVNode(_unref(IonItemOption), {
                color: "primary",
                onClick: ($event: any) => (showPlacesForStocktaingDocument(document.attributes))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Main places ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["documents", "max-documents", "onLoadMore"]),
          _createVNode(FIDocumentPlacesModal, {
            places: _unref(places),
            "is-open": _unref(aggregationPlacementModal).isOpen,
            "is-all-warehouse": _unref(isAllWarehouse),
            "is-more-items-to-load": _unref(canLoadMoreItems)
          }, null, 8, ["places", "is-open", "is-all-warehouse", "is-more-items-to-load"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})